import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { QuestionsTrueFalseConfig } from '@core/models/built/procedure-step-config.model';
import { QuestionAnswerJson } from '@core/models/built/session-step-value-json.model';
import { SessionStepValueType } from '@core/models/built/session-step-value-type.enum';
import { SessionStep, SessionStepValue } from '@core/models/session.model';
import { filterTruthy } from '@utils';
import { DateTime } from 'luxon';
import { BehaviorSubject } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Component({
  templateUrl: './input-true-false-multi-session.component.html',
  styles: [
    `
    .mat-button-toggle-group-appearance-standard {
      border: none !important;
      border-radius: 0px;
    }
    mat-button-toggle {
      border: 3px solid #fff !important;
    }

    mat-button-toggle.selected {
      border: 3px solid #076634 !important;
    }
    `
  ]
})
export class InputTrueFalseMultiSessionComponent implements OnInit {

  @Input() step!: SessionStep;

  @Output() commitAndNext = new EventEmitter<SessionStep>();

  private step$$ = new BehaviorSubject<SessionStep | undefined>(undefined);
  private step$ = this.step$$.pipe(filterTruthy());

  inputForm$ = this.step$.pipe(
    map(step => (step.procedureStep?.config as QuestionsTrueFalseConfig).questions),
    filterTruthy(),
    map(questions => {
      const form = this.fb.group({
        values: this.fb.array(questions.map(q =>
          this.fb.group({
            question: [q, Validators.required],
            answer: [undefined, Validators.required]
          })) || [])
      });
      return form;
    })
  );

  arrayFrmGrp$ = this.inputForm$.pipe(
    map(form => (form.get('values') as FormArray)?.controls as FormGroup[])
  );

  constructor(
    private fb: FormBuilder
  ) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.step) {
      this.step$$.next(changes.step.currentValue);
    }
  }

  submit(form: FormGroup) {
    this.step$.pipe(
      first()
    ).subscribe((step) => {
      if (!form.invalid) {
        const now = DateTime.local().toJSDate();
        const values: SessionStepValue[] = form.value.values.map((val: QuestionAnswerJson) => ({
          workflowId: step.workflowId,
          workflowStepId: step.workflowStepId,
          sessionId: step.sessionId,
          timestamp: now,
          type: SessionStepValueType.questionAnswer,
          value: { question: val.question, answer: val.answer === 'true' },
        }));
        this.commitAndNext.emit({ ...step, completedOn: now, values });
      }
    });
  }
}
